module.exports = __webpack_public_path__ + "static/media/1015895.996ab98a.png";